export default __webpack_public_path__ + "static/media/audit.a3f9e689.png";